import axiosInstance from "../../../interceptor/intercetptor-inctence";

export const getTransactionList = (formData) => {
    return axiosInstance.post(`api/lab-transaction/payment-list`, formData);
}

export const getTransactionDetail = (id) => {
    return axiosInstance.post(`api/lab-transaction/patient-payment-list/${id}`,{});
}

export const getInvoiceDetail = (id) => {
    return axiosInstance.post(`api/report/invoice-data/${id}`,{});
}

export const paymentPatient = (formData) => {
    return axiosInstance.post(`api/test-payment/pay-pending-amount`,formData);
}

// export const addTest = (formData) => {
//     return axiosInstance.post(`api/test/create`,formData);
// }

// export const updateTest = (formData) => {
//     return axiosInstance.post(`api/test/update`,formData);
// }

// export const viewTest = (id) => {
//     return axiosInstance.post(`api/test/get?testId=${id}`,{});
// }

// export const masterDepartment = () => {
//     return axiosInstance.post(`api/master/department/master-list`,{});
// }

// export const masterSample = () => {
//     return axiosInstance.post(`api/master/samle-type/master`,{});
// }

// export const masterTest = () => {
//     return axiosInstance.post(`api/master/test-method/list `,{});
// }

// export const masterParameter = () => {
//     return axiosInstance.post(`api/parameters/master-list`,{});
// }

